import React, { Component } from 'react';
import './Select.css';

class Select extends Component {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		this.props.onChange(e.target.value);
	}

	_renderOptions() {
		const options = this.props.optionsById.map((v, i) => {
			if (this.props.currentVal === null && i === -990) {
				return (
					<option key={v} value={this.props.options[v].id}>
						{this.props.prompt}
					</option>
				);
			}
			if (this.props.matchSquad) {
				return (
					<option key={v} value={this.props.options[v].surname.replace(/\s+/g, '').toLowerCase()}>
						{this.props.options[v].firstName + ' ' + this.props.options[v].surname}
					</option>
				);
			}
			return (
				<option key={v} value={this.props.options[v].id}>
					{this.props.options[v].name}
				</option>
			);
		});
		return options;
	}

	_renderPrompt = () => (!this.props.prompt ? null : <option>{this.props.prompt}</option>);

	render() {
		return (
			<select value={this.props.currentVal} onChange={this.onChange}>
				{this._renderPrompt()}
				{this._renderOptions()}
			</select>
		);
	}
}

export { Select };



// WEBPACK FOOTER //
// ./src/components/inputs/select/Select.js